<div class="container">
    <div class="editorItem">
        <div class="label">Contact</div>
        @if (selectedItem && isReadOnly) {
            <app-internal-navigator
                [path]="routeToSingle"
                [label]="selectedItem.fullName"
                [isActive]="selectedItem.isActive"
            ></app-internal-navigator>
        } @else {
            <app-type-ahead-contacts
                [companyId]="companyId"
                [displaySelected]="displaySelectedContact"
                [selectedContact]="selectedItem"
                (selectedContactChange)="onSelectedContact($event)"
                [isReadOnly]="isReadOnly"
                [path]="routeToSingle"
            >
            </app-type-ahead-contacts>
        }
    </div>

    @if (selectedItem) {
        <div class="infoWrapper">
            <ul>
                <li>
                    <div class="infoLabel">Position</div>
                    <div class="infoValue">{{ contactInfo.position }}</div>
                </li>
                <li>
                    <div class="infoLabel">Email</div>
                    <div class="infoValue">{{ contactInfo.email }}</div>
                </li>
                <li>
                    <div class="infoLabel">Phone</div>
                    <div class="infoValue">{{ contactInfo.phone }}</div>
                </li>
            </ul>
        </div>
    }
</div>
